var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 57",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 28.5a9.5 9.5 0 1 1 19 0 9.5 9.5 0 0 1-19 0z",
    fill: "#1ABCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 47.5A9.5 9.5 0 0 1 9.5 38H19v9.5a9.5 9.5 0 1 1-19 0z",
    fill: "#0ACF83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 0h9.5a9.5 9.5 0 1 1 0 19H19V0z",
    fill: "#FF7262"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.5A9.5 9.5 0 0 1 9.5 0H19v19H9.5A9.5 9.5 0 0 1 0 9.5z",
    fill: "#F24E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.5A9.5 9.5 0 0 1 9.5 19H19v19H9.5A9.5 9.5 0 0 1 0 28.5z",
    fill: "#A259FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.e0a6f964e6e491edf8f241c1400c6ce8.svg";
export { ForwardRef as ReactComponent };